module.exports = require('./src/HashArray.js');